exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-search-protocol-component .help p.success{color:#48c78e}.modal-search-protocol-component .help p.danger{color:#f14668}.modal-search-protocol-component .help p .icon{margin-left:8px;width:auto}.modal-search-protocol-component .help p .icon .mdi:before{font-size:12px}.modal-search-protocol-component .content-btn{margin-top:20px;text-align:right}.modal-search-protocol-component .content-wrap{margin-top:30px}.modal-search-protocol-component .modal-card-body{padding:2.4rem}", ""]);

// exports
